import {isLoggedIn} from 'utils/auth'

export default (store) => {
  return ({
    path: 'journey/create',
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure([], (require) => {
        const journeyBuilderCreate = require('./JourneyCreate').default
        cb(null, journeyBuilderCreate)
      }, 'journeyBuilder')
    }
  })
}



// WEBPACK FOOTER //
// ./src/routes/JourneyBuilder/JourneyCreate/index.js